import { addProp } from "@pnp/odata";
import { _Web } from "../webs/types.js";
import { RegionalSettings } from "./types.js";
import { getValueForUICultureBinder } from "./funcs.js";
addProp(_Web, "regionalSettings", RegionalSettings);
_Web.prototype.titleResource = getValueForUICultureBinder("titleResource");
_Web.prototype.descriptionResource = getValueForUICultureBinder("descriptionResource");
//# sourceMappingURL=web.js.map